import script from "./SuccessToast.vue?vue&type=script&lang=ts"
export * from "./SuccessToast.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__